import React from "react";
import styled from "styled-components";

const Root = styled.div`
  background: #fff;
  border: 1px solid ${props => props.theme.colors.primary.red};
  box-sizing: border-box;
  box-shadow: 0px 4px 28px rgba(0, 0, 0, 0.25);
  border-radius: 0.4rem;
  padding: 1.6rem;

  display: flex;
  align-items: center;
`;

const IconContainer = styled.div`
  margin-right: 1.4rem;
  svg {
    fill: ${props => props.theme.colors.primary.red};
  }
`;

const Text = styled.div`
  color: ${props => props.theme.colors.primary.red};
  font-size: 1.2rem;
  font-weight: ${props => props.theme.fontWeight.regular};
`;

export const ErrorToast = ({ icon, text }) => {
  return (
    <Root>
      {icon && <IconContainer>{icon}</IconContainer>}
      <Text>{text}</Text>
    </Root>
  );
};
